import { useTranslation } from 'react-i18next';

import { Select } from '@actual-app/components/select';
import type { AccountEntity } from '@actual-app/core/types/models';

import { useAccountGroups } from '#hooks/useAccountGroups';

type AccountGroupSelectProps = {
  value: AccountEntity['group'];
  onChange: (value: AccountEntity['group']) => void;
  'aria-label'?: string;
  id?: string;
};

export function AccountGroupSelect({
  value,
  onChange,
  'aria-label': ariaLabel,
  id,
}: AccountGroupSelectProps) {
  const { t } = useTranslation();
  const { data: groups = [] } = useAccountGroups();
  const options: [string, string][] = [
    ['', t('Ungrouped')],
    ...groups
      .filter(group => !group.tombstone)
      .sort((a, b) => a.sort_order - b.sort_order || a.id.localeCompare(b.id))
      .map(group => [group.id, group.name] as [string, string]),
  ];
  return (
    <Select
      aria-label={ariaLabel ?? t('Group')}
      id={id}
      options={options}
      value={value ?? ''}
      onChange={next => onChange(next || null)}
    />
  );
}
